module.exports = __webpack_public_path__ + "img/HNYT087_13.f80da356.gif";